import cx from "classnames";
import React from "react";

import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

export type ProgressBarProps = {
  currentStep: number;
  totalSteps: number;
  label?: string;
  className?: string;
};

export const ProgressBar = ({
  currentStep,
  totalSteps,
  label,
  className,
}: ProgressBarProps) => {
  const progressFraction = currentStep / totalSteps;
  return (
    <div className={cx(className)}>
      <div className={styles.barContainer} aria-label={label}>
        <div className={styles.barBg} />
        <div
          role="progressbar"
          data-testid="progress-bar"
          className={styles.bar}
          style={{
            transform: `scale(${progressFraction}, 1)`,
          }}
        />
      </div>
      {label && (
        <Text size="xxs" className={styles.label}>
          {label}
        </Text>
      )}
    </div>
  );
};

export default ProgressBar;
